import { Link, type LinkProps } from "react-router-dom";

import { getBaseWorkspaceUrl } from "features/subscriptions/utils";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";

// this link navigates relative to the selected workspaceId id
// i.e: 'home' becomes workspaces/:workspaceId/home

export default function RelativeLink({ to, ...rest }: LinkProps) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  return (
    <Link to={getBaseWorkspaceUrl(workspaceId, to.toString())} {...rest} />
  );
}
